import React from "react";
import i18n from "../../../i18n";
import ReportGeneric from "../ReportGeneric";
import DrawStressGraphList, { DrawStressGraph } from "../../../components/report/stress";
import ListOnlyPanel from "../ReportGenericListOnlyPanel";
import ReportAction from "../../../actions/ReportAction";
import { getStressFilterEmployees } from "../../../actions/OrganizationAction";
import ReportGenericIndividual from "../ReportGenericIndividual";
import { stressFilterToBread, stressFilterToRequest } from "../../../util/report";

export const getExportAll = (dateRange)=>ReportAction.exportStressExcel({dateRange});
/**
 * Get export non compare excel file promise by dateRange
 * @param {any} primaryTarget
 * @param {moment[]} dateRange 
 * @returns {Promise} queryPromise
 */
export const getExportPromise = (primaryTarget, dateRange)=>{
	/**
	 * This api should accept primary target and date range.
	 */
	return ReportAction.exportStressExcel({dateRange});
};
/**
 * Get promise for compare excel file by targetValue, primary and secondary date 
 * @param {any} primaryTarget 
 * @param {moment[]} primaryDate 
 * @param {any} secondaryTarget
 * @param {moment[]} secondaryDate 
 * @returns {Promise} queryPromise
 */
export const getExportComparePromise = (primaryTarget, primaryDate, secondaryTarget, secondaryDate)=>{
	/**
	 * For now there is no api for compare yet, 
	 * so it's do the same sa getExportPromise
	 */
	return ReportAction.exportStressExcel({dateRange:primaryDate});
};

export const StressGeneric = (props)=><ReportGenericIndividual 
	{...props}
	// mockupMessage={"This page is currently use mockup data (graph only) for testing purpose."}
	//getExportAll={getExportAll}
	//getExportPromise={getExportPromise}
	getExportPromise={ReportAction.exportStressFilterExcel}
	fetchDeep={ReportAction.fetchStressSelectByFilter}
	fetchIndividual={ReportAction.fetchStressIndividualByFilter}
	searchEmployee={getStressFilterEmployees}
	filterToRequest={stressFilterToRequest}
	filterToBread={stressFilterToBread}
	header={i18n.t("stress_test")}
	drawSingleGraph={DrawStressGraph}
	drawListGraph={DrawStressGraphList}
/>;
export const StressGenericList = (props)=><ReportGeneric {...props} 
	header={i18n.t("stress_test")}
	// drawSingleGraph={DrawStressGraph}
	drawListGraph={DrawStressGraphList}
	pushOnTypeClick={true}
	PanelDrawer={props.PanelDrawer ? props.PanelDrawer : ListOnlyPanel}
/>;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Stress/index.js